import { render, staticRenderFns } from "./logo-column.vue?vue&type=template&id=030d5f73"
import script from "./logo-column.vue?vue&type=script&lang=js"
export * from "./logo-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports